import http from './../utils/http';

export async function login(email: string, password: string) {
  const {data: response} = await http.post('/auth/login', {email, password});

  return response;
}
